import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import { Box, Collapse, useTheme } from '@mui/material'
import type { ReactElement, ReactNode } from 'react'
import { Children, memo, useEffect, useState } from 'react'
import type { InvoiceRowProps } from './InvoiceRow'
import type InvoiceRow from './InvoiceRow'

export interface CollapsibleInvoiceRowProps {
  label: ReactNode
  value: ReactNode
  children:
    | ReactElement<InvoiceRowProps, typeof InvoiceRow>
    | ReactElement<InvoiceRowProps, typeof InvoiceRow>[]
  defaultExpanded?: boolean
}

const COLLAPSE_DURATION = 200

const CollapsibleInvoiceRow = ({
  label,
  value,
  children,
  defaultExpanded = false,
}: CollapsibleInvoiceRowProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded)
  const [visible, setVisible] = useState(defaultExpanded)
  const { spacing } = useTheme()

  useEffect(() => {
    if (expanded) {
      setVisible(true)
    } else {
      const timer = setTimeout(() => setVisible(false), COLLAPSE_DURATION)
      return () => clearTimeout(timer)
    }
  }, [expanded])

  return (
    <>
      {Children.map(children, (child, index) => (
        <tr key={index} style={{ visibility: visible ? 'visible' : 'collapse' }}>
          <td style={{ paddingLeft: spacing(2) }}>
            <Collapse in={expanded} timeout={COLLAPSE_DURATION}>
              <Box>{child.props.label}</Box>
            </Collapse>
          </td>
          <td style={{ textAlign: 'right', borderTopWidth: child.props.divider ? 1 : undefined }}>
            <Collapse in={expanded} timeout={COLLAPSE_DURATION}>
              <Box>{child.props.value}</Box>
            </Collapse>
          </td>
          <td>
            <Collapse in={expanded} timeout={COLLAPSE_DURATION}>
              <Box>{child.props.actions}</Box>
            </Collapse>
          </td>
        </tr>
      ))}
      <tr onClick={() => setExpanded(!expanded)} style={{ cursor: 'pointer' }}>
        <td>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: spacing(0.5) }}>
            <ArrowForwardIosSharpIcon
              sx={{
                fontSize: '0.7rem',
                transform: expanded ? 'rotate(-90deg)' : 'rotate(0deg)',
                transition: 'transform 150ms',
              }}
            />
            {label}
          </span>
        </td>
        <td style={{ textAlign: 'right' }}>{value}</td>
        <td></td>
      </tr>
    </>
  )
}

export default memo(CollapsibleInvoiceRow)
